export enum ImportantDateCategory {
  Anniversary = "Anniversary",
  Memorial = "Memorial",
  Celebration = "Celebration",
  Other = "Other",
}

export interface PatientImportantDate {
  id: string;
  patientId?: string;
  title: string;
  month: number;
  day: number;
  year?: number;
  category: ImportantDateCategory;
  personId?: string;
}
